import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, X, Navigation } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

const LocationReminder = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user) return;

    const dismissed = sessionStorage.getItem('location_reminder_dismissed');
    if (dismissed) return;

    const addresses = user.addresses || [];
    if (addresses.length === 0) return;

    const hasAddressWithoutLocation = addresses.some(
      addr => !addr.latitude || !addr.longitude
    );

    if (hasAddressWithoutLocation) {
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, user]);

  const handleDismiss = () => {
    setShow(false);
    sessionStorage.setItem('location_reminder_dismissed', 'true');
  };

  const handleGoToCheckout = () => {
    handleDismiss();
    navigate('/profile');
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="bg-gradient-to-r from-amber-50 to-orange-50 border-b border-amber-200"
          data-testid="location-reminder-banner"
        >
          <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="w-9 h-9 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                <Navigation className="w-4 h-4 text-amber-600" />
              </div>
              <p className="text-sm text-amber-800 font-medium truncate">
                Adresinize konum ekleyin, teslimat daha kolay olsun!
              </p>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <Button
                onClick={handleGoToCheckout}
                size="sm"
                className="bg-amber-500 hover:bg-amber-600 text-white rounded-full text-xs px-4 h-8"
                data-testid="location-reminder-update-btn"
              >
                <MapPin className="w-3 h-3 mr-1" />
                Konum Ekle
              </Button>
              <button
                onClick={handleDismiss}
                className="p-1.5 hover:bg-amber-100 rounded-full transition-colors"
                data-testid="location-reminder-dismiss-btn"
              >
                <X className="w-4 h-4 text-amber-600" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LocationReminder;
